jQuery.feature_import("js-mediapicker",
  () => require("./mediapicker.js"),
  mod => mod.feature_js_mediapicker
);